import { getForegroundColor, createIconComponentFromSimpleIconsSvgPath } from '@consent-manager/core';
import { siAlgolia } from 'simple-icons';

function algoliaIntegration() {
  var title = siAlgolia.title,
    slug = siAlgolia.slug,
    hex = siAlgolia.hex,
    path = siAlgolia.path;
  var color = "#" + hex;
  var contrastColor = getForegroundColor(color);
  var Icon = createIconComponentFromSimpleIconsSvgPath(title, path);
  return {
    id: slug,
    title: title,
    category: 'Search',
    color: color,
    contrastColor: contrastColor,
    Icon: Icon,
    privacyPolicyUrl: "https://www.algolia.com/policies/privacy/",
    description: 'We use Algolia to provide you a high performant and feature-rich search experience.'
  };
}

export { algoliaIntegration };
//# sourceMappingURL=integration-algolia.esm.js.map
